module.exports = __webpack_public_path__ + "static/media/test3_1.8c4b3c99.png";